import {
    IconDeviceDesktopAnalytics,
    IconFileText,
    IconAlertSquareRounded,
    IconBuilding,
} from '@tabler/icons-react';
import { matchPath } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SITE_ROUTE_PATH } from 'utils/constants';

const NAVIGATION_LINKS = [
    {
        id: 'site',
        icon: IconDeviceDesktopAnalytics,
        text: 'layout:navigation-links:sites-monitoring:text',
        altText: 'layout:navigation-links:sites-monitoring:altText',
        href: '/',
        isActiveLink: (pathname: string) =>
            Boolean(matchPath('sites', pathname)) ||
            Boolean(matchPath(SITE_ROUTE_PATH, pathname)),
    },
    {
        id: 'navigation-companies',
        icon: IconBuilding,
        text: 'layout:navigation-links:companies:text',
        altText: 'layout:navigation-links:companies:altText',
        href: '/companies',
        reloadOnActive: true,
    },
    {
        id: 'navigation-alerts',
        icon: IconAlertSquareRounded,
        text: 'layout:navigation-links:alerts:text',
        altText: 'layout:navigation-links:alerts:altText',
        href: '/alerts',
    },
    {
        id: 'navigation-logs',
        icon: IconFileText,
        text: 'layout:navigation-links:logs:text',
        altText: 'layout:navigation-links:logs:altText',
        href: '/logs',
        reloadOnActive: true,
    },
];

const HELP_LINKS = [
    {
        id: 'help',
        text: 'layout:help-menu:help',
        altText: 'layout:help-menu:help',
        href: 'https://support.bigleaf.net/',
    },
    {
        id: 'ticket',
        text: 'layout:help-menu:submit',
        altText: 'layout:help-menu:submit',
        href: 'https://support.bigleaf.net/hc/en-us/requests/new?ticket_form_id=318967',
    },
    {
        id: 'status',
        text: 'layout:help-menu:status',
        altText: 'layout:help-menu:status',
        href: 'https://status.bigleaf.net/',
    },
    {
        id: 'versa_pay',
        text: 'layout:help-menu:versa_pay',
        altText: 'layout:help-menu:versa_pay',
        href: 'https://secure.versapay.com/choose_supplier',
    },
    {
        id: 'partner',
        text: 'layout:help-menu:partner',
        altText: 'layout:help-menu:partner',
        href: 'https://partner.bigleaf.net/',
    },
];

export const useNavigationLinks = () => {
    const { t } = useTranslation();

    return {
        navigationLinks: NAVIGATION_LINKS.map((link) => ({
            ...link,
            text: t(link.text),
            altText: t(link.altText),
        })),
        helpLinks: HELP_LINKS.map((link) => ({
            ...link,
            text: t(link.text),
            altText: t(link.altText),
        })),
    };
};
